import { CustomerSchema } from "@redotech/redo-customer-common/customer";
import * as z from "zod";

export const getCustomer = {
  name: "getCustomer" as const,
  input: z.object({ customerId: z.string() }),
  output: CustomerSchema,
};
